import { Frame as FrameIcon } from 'lucide-react'
import { NodeKind } from '@/core/document'
import { FramePanel } from '@/tools/frame/FramePanel'
import { ToolKind, ToolTab, type NodeTool } from '@/tools/types'

export const FRAME_TOOL = {
  kind: ToolKind.Node,
  tab: ToolTab.Frame,
  node: NodeKind.Frame,
  label: 'Frame',
  icon: FrameIcon,
  appliesTo: (node) => node?.kind === NodeKind.Image,
  Panel: FramePanel,
} satisfies NodeTool
